import request from "./request";
import { setToStorage, getFromStorage } from "./utils";

const cred = "?product=" + process.env.VUE_APP_KEY;

// TODO move cred to request intercepters

export function getBookList() {
  return request.get(`/v1/card_list/country/ph${cred}`);
}

export function getBookInfo(id) {
  return request.get(`/v1/detail/${id}${cred}`);
}

export function batchGetBookInfo(data) {
  return request.post(`/v1/batch/detail${cred}`, data);
}

export function getBookChapters(bookId) {
  return request.get(`/v1/chapters/${bookId}${cred}`);
}

export function getBookContent(bookId, chapterId) {
  return request.get(`/content/${bookId}/${chapterId}${cred}`, {
    responseType: "blob"
  });
}

export function getShelfRecommend() {
  return request.get(`/v1/card/shelf/country/ph${cred}`);
}

// ==== below are currently to localStorage ==== //

/**
 * local object， to match the api response
 * [{
 *    book_id: xx,
 *    book_name: xx, // not used for now, just for checking
 *    chapter_id: xx,
 *    chapter_index: xx,
 *    chapter_count: xx
 * }]
 */
const LOCAL_LIB_KEY = "LOCAL_LIB";

function updateLocalLibStatus(ids, status) {
  const localHistory = getLocalReadProgress();
  for (let i = 0; i < ids.length; i++) {
    const bookId = ids[i];
    const index = localHistory.map(i => i.book_id).indexOf(bookId);
    if (index > -1) {
      localHistory[index].inLib = status;
      localHistory[index].last_update = Date.now();
    }
  }
  setToStorage(LOCAL_LIB_KEY, localHistory);
}

export function saveBooksToLocalLib(bookId) {
  updateLocalLibStatus([bookId], true);
}

export function removeBooksToLocalLib(ids) {
  updateLocalLibStatus(ids, false);
}

export function getLibBooksFromLocal() {
  const localHistory = getLocalReadProgress();
  return localHistory.filter(b => b.inLib).sort((a, b) => (b.last_update || 0) - (a.last_update || 0));
}

export function updateLocalReadProgress(data, extra) {
  const localHistory = getLocalReadProgress();
  // prepare lasted data
  const { book_id, chapter_id, book_name, chapters } = data;
  const chapter_index = chapters.map(i => i.id).indexOf(chapter_id);
  const merged = {
    book_id,
    chapter_id,
    book_name,
    chapter_index,
    chapter_count: chapters.length,
    last_chapter_name: extra.name, // new added
    last_update: Date.now() // new added, for sorting
  };
  // check is new
  const bookIndex = localHistory.map(i => i.book_id).indexOf(book_id);
  if (bookIndex > -1) {
    // => already has it, just replace
    localHistory[bookIndex] = Object.assign({}, localHistory[bookIndex], merged);
  } else {
    localHistory.push(merged);
  }
  // set local data back
  setToStorage(LOCAL_LIB_KEY, localHistory);
}

export function getLocalReadProgress(bookId) {
  const all = getFromStorage(LOCAL_LIB_KEY) || [];
  if (bookId) {
    const matched = all.filter(b => b.book_id === bookId);
    return matched[0];
  }
  return all.sort((a, b) => (b.last_update || 0) - (a.last_update || 0));
}

export function getLastRead() {
  const records = getLocalReadProgress();
  const book = records[0];
  if (book) {
    return batchGetBookInfo({
      book_ids: [book.book_id]
    }).then(res => Object.assign({}, res[0] || {}, book));
  } else {
    return Promise.resolve(null); // hide modal in component
  }
}

export function getRecommendByBook(bookId) {
  return request.get(`/v1/recommend_by_book/${bookId}${cred}`);
}
